import { Entity } from '@adornis/baseql/decorators.js';
import { BaseEditExtension } from '../BaseEditExtension.js';

/**
 * @entity BaseKPFEditRAGReportingExtension
 */
@Entity()
export class BaseKPFEditRAGReportingExtension extends BaseEditExtension {
  public static override _class = 'BaseKPFEditRAGReportingExtension';
}
